import ApplicationLogo from '@/Components/ApplicationLogo'
import { Link, usePage } from '@inertiajs/react'
import React, { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { SocialIcon } from 'react-social-icons';

import earth from '@/../../public/footer/offices-globe.mp4';
import logodarkomde from '@/../../public/logo_darkmode.png';
import mobawon from '@/../../public/footer/logo-no-background.png';

export default function Footer() {
    const { t, i18n } = useTranslation();
    const currentYear = new Date().getFullYear();
    const { laravelsocial }: [] | any = usePage().props;


    const [hoverIcons, setHoverIcons] = useState<Record<number, boolean>>({});
    const handleMouseEnter = (id: number) => {
        setHoverIcons((prev) => ({ ...prev, [id]: true }));
    };

    const handleMouseLeave = (id: number) => {
        setHoverIcons((prev) => ({ ...prev, [id]: false }));
    };


    return (
        <footer className='relative bg-custom-sky-blue text-white dark:bg-black'

        >

            <div className='max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6 lg:py-8 relative'>
                <div className={`pointer-events-none cursor-none absolute  h-40 ${i18n.language === 'ar' ? 'left-0' : 'right-0'} xs:hidden`}>
                    <video src={earth}
                        autoPlay
                        muted
                        loop
                        playsInline
                        className='mix-blend-screen w-full h-full'

                    ></video>
                </div>
                <div className='grid grid-cols-2 xs:grid-cols-1 xs:gap-3'>
                    <div className='flex'>

                    <div className='flex flex-col items-center'>
                        <Link href="/" >

                            <img loading='lazy' src={logodarkomde} className=" h-20 " />
                        </Link>
                        <div className='flex flex-col item-center'>
                        {laravelsocial.length > 0 ?
                            (

                                <div className='flex justify-center items-center mr-6 ' >
                                    {laravelsocial?.map((socail: any) =>
                                    (

                                        <SocialIcon key={socail.id}
                                            className='mx-2'
                                            bgColor="transparent"
                                            fgColor={hoverIcons[socail.id] ? '#0033A0' : 'white'}
                                            network={socail.name === 'tr' ? 'linktree' : ''}
                                            url={socail.social_link}
                                            target='_blank'
                                            style={{ height: 40, width: 40 }}
                                            onMouseEnter={() => handleMouseEnter(socail.id)}
                                            onMouseLeave={() => handleMouseLeave(socail.id)}
                                        />
                                    )

                                    )}
                                </div>
                            )

                            :
                            <div className='flex items-center gap-4 p-2'>

                                <SocialIcon className='mx-2' bgColor="transparent" fgColor="black" network='facebook' target='_blank' style={{ height: 15, width: 15 }} />
                                <SocialIcon className='mx-2' bgColor="transparent" fgColor="black" network='x' target='_blank' style={{ height: 15, width: 15 }} />
                                <SocialIcon className='mx-2' bgColor="transparent" fgColor="black" network='instagram' target='_blank' style={{ height: 15, width: 15 }} />
                                <SocialIcon className='mx-2' bgColor="transparent" fgColor="black" network='linkedin' target='_blank' style={{ height: 15, width: 15 }} />
                                <SocialIcon className='mx-2' bgColor="transparent" fgColor="black" network='youtube' target='_blank' style={{ height: 15, width: 15 }} />

                            </div>
                        }

                            <Link href={route('client.contactus.index')} className='hover:text-custom-dark-blue'>
                        <p className=' lg:text-base text-sm font-bold mr-6 '>{t('footer.contactus')}</p>
                            </Link>
                        </div>
                    </div>
                    </div>

                    <div className='grid grid-cols-2 gap-4 lg:text-base text-sm text-center'>

                        <Link href='/' className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base '>{t('topbar.home')}</Link>

                        <Link href={route('client.department.index', { locale: i18n.language })} className='hover:text-custom-dark-blue font-sans font-bold text-base lg:text-sm'>
                            {t('topbar.department')}
                        </Link>

                        <Link href={route('client.specialdoctor.doctors', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.ourdoctors')}
                        </Link>

                        <Link href={route('client.news.index', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.mecialnews')}
                        </Link>

                        <Link href={route('client.blogs.index', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.magazine')}
                        </Link>

                        <Link href={route('client.achievements.index', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.achievemnets')}
                        </Link>

                        <Link href={route('client.offers.index', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.offers')}
                        </Link>

                        <Link href={route('client.contactus.index', { locale: i18n.language })} className='hover:text-custom-dark-blue  font-sans font-bold text-sm lg:text-base'>
                            {t('topbar.contactus')}
                        </Link>
                    </div>
                </div>
                <div className='flex justify-center items-center flex-col my-5 gap-4'>

                    <div className='flex justify-center items-center'>
                        <div>{t('footer.copyright')} © {currentYear}</div>
                    </div>

                    <a href="https://direct.me/dmcreators" target='_blank'>
                        <img loading='lazy' src={mobawon} className='object-cover h-10' />
                    </a>

                    <p className='py-2 text-center font-bold'>
                        {t('footer.mobdwon')}
                        <a href='https://direct.me/dmcreators' target='_blank' className='hover:text-custom-dark-blue'>{t('footer.mobdwon_link')}</a>
                    </p>
                </div>

            </div>
        </footer>
    )
}
